import React, {useState} from 'react';
import Button from "../../UI/Button";
import objectDataHolder from "../../Hooks/ObjectDataHolder";

const RoleSection = ({
                       roles,
                       reverseActive,
                       onChange,
                       onSave
                     }) => {


  const changeHandler = (e) => {
    //reverseActive()
    onChange(e.target.value);
  }

  return (
    <div className={'d-flex justify-content-center align-items-center '}>
      <div>
        <label htmlFor="roles" className={'mx-2'}>نقش:</label>
        <select
          className={'role__selected'}
          id={'roles'}
          value={roles.selectedRole}
          onChange={changeHandler}
        >
          <option value="">انتخاب کنید</option>
          {roles.array.map((v, index) =>
            <option key={index + v} value={v}>{v}</option>)}
        </select>
        <input
          className={'me-3'}
          id={'roleConfig'}
          type={"checkbox"}
          checked={roles.activeConfiguration}
          // onClick={reverseActive}
          onChange={reverseActive}

        />

        <label htmlFor={'roleConfig'}>پیکربندی</label>


      </div>
      <div
        style={{visibility: roles.activeConfiguration ? 'visible' : 'hidden'}}
      >
        <button
          className=" mx-3 btn btnCustom btnSubmit submit-button"
          onClick={onSave}
        >ذخیره
        </button>
      </div>

    </div>
  );
};

export default RoleSection;
